import styled from 'styled-components';
import LinearProgressProps from './type';

export const LinearProgressColorStyled = styled.div<LinearProgressProps>`
  width: ${({ value }) => `${value}%` || '0%'};
  max-width: ${({ value }) => `calc(${value})%` || '0%'};
  height: ${({ size }) => size || '12px'};
  border-radius: 10px;
  background: ${({ theme: { colors }, value }) => {
    if (value < 100) {
      return `linear-gradient(to right, #50CAFF, ${colors.blue500})`;
    }
    return `linear-gradient(to right,#7FB418,#95D21C)`;
  }};
`;

export const LinearProgressWrapperStyled = styled.div<LinearProgressProps>`
  box-shadow: 4px 4px 14px 0px #c1d5ee inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
  background-color: #e3edf7;
  border-radius: 10px;
`;
